import React from 'react';

import ErrorIcon from '@mui/icons-material/Error';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import dompurify from 'dompurify';

import { DARK_GREY } from '../../../ThemeContext/constants';
import { classes } from '../Multiposter/styles';

import type { IWarningDialogProps } from '../Multiposter/types';

const WarningDialog = ({
  title,
  description,
  buttonText,
  isDialogOpen,
  setDialogOpen
}: IWarningDialogProps) => (
  <Dialog open={isDialogOpen} sx={{ '& .MuiPaper-root': classes.dialog }}>
    <ErrorIcon sx={{ color: '#E37D7A', fontSize: '70px' }} />
    <Box sx={{ color: DARK_GREY, marginBottom: '10px' }}>
      <h1>{title}</h1>
    </Box>
    {description ? (
      <Box dangerouslySetInnerHTML={{ __html: dompurify.sanitize(description) }} />
    ) : null}
    <Box sx={classes.dialogButtonContainer}>
      <Button
        disableElevation
        onClick={() => setDialogOpen(false)}
        style={{ padding: '10px 30px' }}
        sx={classes.buttonSecondary}
      >
        {buttonText}
      </Button>
    </Box>
  </Dialog>
);

export default WarningDialog;
